import { BaseURL } from "./baseUrl.js";
import { selfAxios } from "./selfAxios.js";
import { useInterceptor } from "axios-interceptor";
import { merge } from "lodash-es";
import { ref } from "vue-demi";
import { currentEnvMode } from "../utils/currentEnvMode.js";
function initSelfAxios(arg) {
  const { envMode, axiosDefaults, isRetry } = arg;
  currentEnvMode.value = envMode;
  const baseURL = BaseURL[envMode];
  selfAxios.defaults.baseURL = baseURL;
  const requestList = ref([]);
  const { doRetry } = useInterceptor({
    axios: selfAxios,
    useCache: {
      isSuccess(v) {
        return v.status >= 200 && v.status < 300 && v.data.code === "100000";
      }
    },
    useDebounce: true,
    useTimestamp: true,
    useRetry: {
      isRetry
    },
    useChange: {
      requestListChange(configs) {
        requestList.value = configs;
      }
    }
  });
  merge(selfAxios.defaults, axiosDefaults);
  return {
    requestList,
    doRetry
  };
}
export { initSelfAxios };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/axios/initSelfAxios.js